import { createAction } from "redux-actions";

// Get product group
export const REQUESTED_PRODUCT_GROUPS = "REQUESTED_PRODUCT_GROUPS";
export const RECEIVED_PRODUCT_GROUPS = "RECEIVED_PRODUCT_GROUPS";

export const requestProductGroups = createAction(REQUESTED_PRODUCT_GROUPS);
export const receiveProductGroups = createAction(
  RECEIVED_PRODUCT_GROUPS,
  (productGroups) => ({ productGroups })
);

// Create product group
export const REQUESTED_CREATE_PRODUCT_GROUP = "REQUESTED_CREATE_PRODUCT_GROUP";
export const RECEIVED_CREATE_PRODUCT_GROUP = "RECEIVED_CREATE_PRODUCT_GROUP";

export const requestCreateProductGroup = createAction(
  REQUESTED_CREATE_PRODUCT_GROUP
);
export const receiveCreateProductGroup = createAction(
  RECEIVED_CREATE_PRODUCT_GROUP,
  (productGroups) => ({ productGroups })
);

// Update product group
export const REQUESTED_UPDATE_PRODUCT_GROUP = "REQUESTED_UPDATE_PRODUCT_GROUP";
export const RECEIVED_UPDATE_PRODUCT_GROUP = "RECEIVED_UPDATE_PRODUCT_GROUP";

export const requestUpdateProductGroup = createAction(
  REQUESTED_UPDATE_PRODUCT_GROUP
);
export const receiveUpdateProductGroup = createAction(
  RECEIVED_UPDATE_PRODUCT_GROUP,
  (productGroups) => ({ productGroups })
);

// Delete product group
export const REQUESTED_DELETE_PRODUCT_GROUP = "REQUESTED_DELETE_PRODUCT_GROUP";
export const RECEIVED_DELETE_PRODUCT_GROUP = "RECEIVED_DELETE_PRODUCT_GROUP";

export const requestDeleteProductGroup = createAction(
  REQUESTED_DELETE_PRODUCT_GROUP
);
export const receiveDeleteProductGroup = createAction(
  RECEIVED_DELETE_PRODUCT_GROUP,
  (productGroups) => ({ productGroups })
);
